import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface ValuationSummary {
  slug: string;
  symbol: string;
  name: string;
  price: number;
  market_cap: number;
  rank: number;
  change_24h: number;
  image: string;
  tvl: number | null;
  tvl_source: 'protocol' | 'chain' | 'none' | 'unknown';
  tvl_source_label: string | null;
  tvl_source_key: string | null;
  fees_7d: number;
  revenue_7d: number;
  has_tvl: boolean;
  has_fees: boolean;
  has_revenue: boolean;
}

export interface ValuationSummaryData {
  updated_at: string;
  count: number;
  items: ValuationSummary[];
}

export const useValuationSummary = () => {
  return useQuery({
    queryKey: ['valuation-summary'],
    queryFn: async (): Promise<ValuationSummaryData> => {
      console.log('Fetching valuation summary...');
      
      const { data, error } = await supabase.functions.invoke('valuation-summary');
      
      if (error) {
        console.error('Valuation summary error:', error);
        throw new Error(`Failed to fetch valuation summary: ${error.message}`);
      }
      
      console.log('Valuation summary received:', data?.items?.length || 0, 'assets');
      
      return data;
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
    refetchInterval: 5 * 60 * 1000, // Auto-refresh every 5 minutes
    retry: 3,
    retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
  });
};